import React from "react";
import colors from "../../assets/colors";
import CloseIcon from "../Icons/CloseIcons";
import SimpleButton from "../SimpleButton";
import DateBadge from "./DateBadge";

interface Props {
  imgUrl1?: string;
  date1?: Date;
  imgUrl2?: string;
  date2?: Date;
  onDelete1?: () => void;
  onDelete2?: () => void;
}

const PhotosPicker = (props: Props) => {
  const { imgUrl1, imgUrl2, date1, date2, onDelete1, onDelete2 } = props;

  const isFirstHighlighted = !imgUrl1;
  const isSecondHighlighted = !imgUrl2 && !isFirstHighlighted;

  return (
    <div
      className="d-flex"
      style={{
        width: 280,
        height: 280,
        backgroundColor: colors.caliber_white,
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        padding: 4,
        position: "relative",
      }}
    >
      {imgUrl1 ? (
        <div
          style={{
            width: 134,
            height: 272,
            marginRight: 4,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={imgUrl1}
            style={{
              top: 0,
              left: -35,
              height: 272,
              objectFit: "contain",
              position: "absolute",
            }}
          />
        </div>
      ) : (
        <EmptyImageIcon isSelected={isFirstHighlighted} />
      )}
      {imgUrl2 ? (
        <div
          style={{
            width: 134,
            height: 272,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={imgUrl2}
            style={{
              top: 0,
              left: -35,
              height: 272,
              objectFit: "contain",
              position: "absolute",
            }}
          />
        </div>
      ) : (
        <EmptyImageIcon isSelected={isSecondHighlighted} />
      )}

      {imgUrl1 && (
        <DateBadge
          date={date1}
          style={{
            position: "absolute",
            left: 42,
            top: 21,
          }}
        />
      )}
      {imgUrl2 && (
        <DateBadge
          date={date2}
          style={{
            position: "absolute",
            right: 42,
            top: 21,
          }}
        />
      )}

      {imgUrl1 && (
        <SimpleButton
          onClick={onDelete1}
          style={{
            position: "absolute",
            top: 5,
            left: 117,
          }}
        >
          <CloseIcon />
        </SimpleButton>
      )}
      {imgUrl2 && (
        <SimpleButton
          onClick={onDelete2}
          style={{
            position: "absolute",
            top: 5,
            right: 5,
          }}
        >
          <CloseIcon />
        </SimpleButton>
      )}
    </div>
  );
};

const EmptyImageIcon = ({ isSelected }: { isSelected: boolean }) => {
  if (isSelected) {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: colors.caliber_secondary_gray_11,
          width: 134,
          height: 272,
          border: "3px solid #5B64A0",
          marginRight: 4,
        }}
      >
        <svg
          width="48"
          height="44"
          viewBox="0 0 48 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.0917 17.8318C19.9129 17.8318 21.3894 16.3554 21.3894 14.5341C21.3894 12.7129 19.9129 11.2365 18.0917 11.2365C16.2704 11.2365 14.7939 12.7129 14.7939 14.5341C14.7939 16.3554 16.2704 17.8318 18.0917 17.8318Z"
            fill="#808297"
          />
          <path
            d="M45.1603 26.6717C43.6031 25.2061 41.6336 24.2442 39.4809 23.9694V7.20606C39.4809 5.4198 38.7481 3.81675 37.6031 2.62591C36.4122 1.43507 34.8092 0.748047 33.0229 0.748047H6.45802C4.67176 0.748047 3.0687 1.48087 1.87786 2.62591C0.687023 3.81675 0 5.4198 0 7.20606V28.3206V30.29V34.5496C0 36.3358 0.732824 37.9389 1.87786 39.1297C3.0687 40.3206 4.67176 41.0076 6.45802 41.0076H32.1527C33.8473 42.3816 35.9542 43.2519 38.2901 43.2519C40.9924 43.2519 43.4198 42.1526 45.1603 40.4122C46.9008 38.6717 48 36.2442 48 33.5419C48 30.8396 46.9008 28.4122 45.1603 26.6717ZM2.42748 7.20606C2.42748 6.10683 2.8855 5.09919 3.61832 4.36637C4.35115 3.63354 5.35878 3.17553 6.45802 3.17553H33.0229C34.1221 3.17553 35.1298 3.63354 35.8626 4.36637C36.5954 5.09919 37.0534 6.10683 37.0534 7.20606V21.4961L30.2748 14.7633C29.8168 14.3053 29.0382 14.2595 28.5344 14.7633L18.3206 25.0229L11.4046 18.061C10.9466 17.603 10.1679 17.5572 9.66412 18.061L2.42748 25.3893V7.20606ZM6.41221 38.6259V38.5801C5.31298 38.5801 4.30534 38.1221 3.57252 37.3893C2.8855 36.6564 2.42748 35.6488 2.42748 34.5496V30.29V28.8244L10.5802 20.6717L17.4962 27.5877C17.9542 28.0458 18.7328 28.0458 19.2366 27.5877L29.4504 17.3282L36.1374 24.061C36 24.1068 35.8626 24.1526 35.7252 24.1984C35.542 24.2442 35.3588 24.29 35.1298 24.3816C34.9466 24.4274 34.7634 24.519 34.5802 24.5648C34.4427 24.6106 34.3511 24.6564 34.2137 24.748C34.0305 24.8396 33.8931 24.8855 33.7557 24.9771C33.5267 25.1145 33.2977 25.2519 33.0687 25.3893C32.9313 25.4809 32.8397 25.5267 32.7023 25.6183C32.6107 25.6641 32.5649 25.7099 32.4733 25.7557C32.0611 26.0305 31.6947 26.3511 31.374 26.7175C29.6336 28.458 28.5344 30.8854 28.5344 33.5877C28.5344 34.2748 28.626 34.916 28.7634 35.603C28.8092 35.7862 28.855 35.9236 28.9008 36.1068C29.0382 36.5648 29.1756 37.0229 29.3588 37.4809V37.5267C29.542 37.8931 29.7252 38.3053 29.9542 38.6259H6.41221ZM43.374 38.6717C42.0458 40 40.2595 40.7786 38.2443 40.7786C36.3206 40.7786 34.5344 40 33.2519 38.7633C33.0687 38.5801 32.8855 38.3511 32.7023 38.1679C32.5649 38.0305 32.4275 37.8473 32.2901 37.7099C32.1069 37.4809 31.9695 37.2061 31.8321 36.9313C31.7405 36.748 31.6489 36.6106 31.5573 36.4274C31.4656 36.1984 31.374 35.9236 31.3282 35.6488C31.2824 35.4656 31.1908 35.2366 31.145 35.0534C31.0534 34.5954 31.0076 34.0916 31.0076 33.5877C31.0076 31.5725 31.8321 29.7862 33.1145 28.458C34.4427 27.1297 36.229 26.3511 38.2443 26.3511C40.2595 26.3511 42.0458 27.1755 43.374 28.458C44.7023 29.7404 45.4809 31.5725 45.4809 33.5877C45.4809 35.5572 44.6565 37.3435 43.374 38.6717Z"
            fill="#808297"
          />
          <path
            d="M42.2289 32.3054H39.435V29.5115C39.435 28.8245 38.8854 28.2749 38.1983 28.2749C37.5113 28.2749 36.9617 28.8245 36.9617 29.5115V32.3054H34.1678C33.4808 32.3054 32.9312 32.8551 32.9312 33.5421C32.9312 34.2291 33.4808 34.7787 34.1678 34.7787H36.9617V37.5726C36.9617 38.2596 37.5113 38.8092 38.1983 38.8092C38.8854 38.8092 39.435 38.2596 39.435 37.5726V34.7787H42.2289C42.9159 34.7787 43.4655 34.2291 43.4655 33.5421C43.4655 32.8551 42.9159 32.3054 42.2289 32.3054Z"
            fill="#808297"
          />
        </svg>
      </div>
    );
  }
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: colors.caliber_secondary_gray_11,
        width: 134,
        height: 272,
      }}
    >
      <svg
        width="48"
        height="44"
        viewBox="0 0 48 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0917 17.8318C19.9129 17.8318 21.3894 16.3554 21.3894 14.5341C21.3894 12.7129 19.9129 11.2365 18.0917 11.2365C16.2704 11.2365 14.7939 12.7129 14.7939 14.5341C14.7939 16.3554 16.2704 17.8318 18.0917 17.8318Z"
          fill="#808297"
        />
        <path
          d="M45.1603 26.6717C43.6031 25.2061 41.6336 24.2442 39.4809 23.9694V7.20606C39.4809 5.4198 38.7481 3.81675 37.6031 2.62591C36.4122 1.43507 34.8092 0.748047 33.0229 0.748047H6.45802C4.67176 0.748047 3.0687 1.48087 1.87786 2.62591C0.687023 3.81675 0 5.4198 0 7.20606V28.3206V30.29V34.5496C0 36.3358 0.732824 37.9389 1.87786 39.1297C3.0687 40.3206 4.67176 41.0076 6.45802 41.0076H32.1527C33.8473 42.3816 35.9542 43.2519 38.2901 43.2519C40.9924 43.2519 43.4198 42.1526 45.1603 40.4122C46.9008 38.6717 48 36.2442 48 33.5419C48 30.8396 46.9008 28.4122 45.1603 26.6717ZM2.42748 7.20606C2.42748 6.10683 2.8855 5.09919 3.61832 4.36637C4.35115 3.63354 5.35878 3.17553 6.45802 3.17553H33.0229C34.1221 3.17553 35.1298 3.63354 35.8626 4.36637C36.5954 5.09919 37.0534 6.10683 37.0534 7.20606V21.4961L30.2748 14.7633C29.8168 14.3053 29.0382 14.2595 28.5344 14.7633L18.3206 25.0229L11.4046 18.061C10.9466 17.603 10.1679 17.5572 9.66412 18.061L2.42748 25.3893V7.20606ZM6.41221 38.6259V38.5801C5.31298 38.5801 4.30534 38.1221 3.57252 37.3893C2.8855 36.6564 2.42748 35.6488 2.42748 34.5496V30.29V28.8244L10.5802 20.6717L17.4962 27.5877C17.9542 28.0458 18.7328 28.0458 19.2366 27.5877L29.4504 17.3282L36.1374 24.061C36 24.1068 35.8626 24.1526 35.7252 24.1984C35.542 24.2442 35.3588 24.29 35.1298 24.3816C34.9466 24.4274 34.7634 24.519 34.5802 24.5648C34.4427 24.6106 34.3511 24.6564 34.2137 24.748C34.0305 24.8396 33.8931 24.8855 33.7557 24.9771C33.5267 25.1145 33.2977 25.2519 33.0687 25.3893C32.9313 25.4809 32.8397 25.5267 32.7023 25.6183C32.6107 25.6641 32.5649 25.7099 32.4733 25.7557C32.0611 26.0305 31.6947 26.3511 31.374 26.7175C29.6336 28.458 28.5344 30.8854 28.5344 33.5877C28.5344 34.2748 28.626 34.916 28.7634 35.603C28.8092 35.7862 28.855 35.9236 28.9008 36.1068C29.0382 36.5648 29.1756 37.0229 29.3588 37.4809V37.5267C29.542 37.8931 29.7252 38.3053 29.9542 38.6259H6.41221ZM43.374 38.6717C42.0458 40 40.2595 40.7786 38.2443 40.7786C36.3206 40.7786 34.5344 40 33.2519 38.7633C33.0687 38.5801 32.8855 38.3511 32.7023 38.1679C32.5649 38.0305 32.4275 37.8473 32.2901 37.7099C32.1069 37.4809 31.9695 37.2061 31.8321 36.9313C31.7405 36.748 31.6489 36.6106 31.5573 36.4274C31.4656 36.1984 31.374 35.9236 31.3282 35.6488C31.2824 35.4656 31.1908 35.2366 31.145 35.0534C31.0534 34.5954 31.0076 34.0916 31.0076 33.5877C31.0076 31.5725 31.8321 29.7862 33.1145 28.458C34.4427 27.1297 36.229 26.3511 38.2443 26.3511C40.2595 26.3511 42.0458 27.1755 43.374 28.458C44.7023 29.7404 45.4809 31.5725 45.4809 33.5877C45.4809 35.5572 44.6565 37.3435 43.374 38.6717Z"
          fill="#808297"
        />
        <path
          d="M42.2289 32.3054H39.435V29.5115C39.435 28.8245 38.8854 28.2749 38.1983 28.2749C37.5113 28.2749 36.9617 28.8245 36.9617 29.5115V32.3054H34.1678C33.4808 32.3054 32.9312 32.8551 32.9312 33.5421C32.9312 34.2291 33.4808 34.7787 34.1678 34.7787H36.9617V37.5726C36.9617 38.2596 37.5113 38.8092 38.1983 38.8092C38.8854 38.8092 39.435 38.2596 39.435 37.5726V34.7787H42.2289C42.9159 34.7787 43.4655 34.2291 43.4655 33.5421C43.4655 32.8551 42.9159 32.3054 42.2289 32.3054Z"
          fill="#808297"
        />
      </svg>
    </div>
  );
};

export default PhotosPicker;
